export enum FeatureTutorialID
{
  DailyChallenge = 1,
  DailyTasks = 2,
  ChainOffer = 3,
  Conveyor = 4,
}
